module.exports = __webpack_public_path__ + "media/images/right-arrow-svgrepo-com-c86fcfd280bb480933e04145f02ed798.svg";